var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,17.7h-3.8c-1,0-1.6,0-2.2-.3s0,0-.1,0c-.4-.2-.8-.6-1.1-1.1-.3-.6-.3-1.1-.3-2.2s.4-1,1-1,1,.4,1,1c0,.9,0,1.2,0,1.4,0,0,0,0,0,.1,0,0,.1,0,.2.1.2,0,.7,0,1.3,0h3.8c.9,0,1.2,0,1.4,0,0,0,0,0,.1,0,0,0,0-.1.1-.2,0-.2,0-.7,0-1.3V6c0-.9,0-1.2,0-1.4,0,0,0,0,0-.1,0,0-.1,0-.2-.1-.2,0-.7,0-1.3,0h-3.8c-.9,0-1.2,0-1.4,0,0,0,0,0-.1,0,0,0,0,.1-.1.2,0,.2,0,.5,0,1.3s-.4,1-1,1-1-.4-1-1c0-1.1,0-1.6.3-2.2,0,0,0,0,0-.1.2-.4.6-.8,1.1-1.1.6-.3,1.1-.3,2.2-.3h3.8c1,0,1.6,0,2.2.3,0,0,0,0,.1,0,.4.2.8.6,1.1,1.1.3.6.3,1.1.3,2.2v8c0,1,0,1.6-.3,2.2,0,0,0,0,0,.1-.2.4-.6.8-1.1,1.1-.6.3-1.1.3-2.2.3ZM10,13.5c-.3,0-.5,0-.7-.3-.4-.4-.4-1,0-1.4l.8-.8H3.3c-.6,0-1-.4-1-1s.4-1,1-1h6.8l-.8-.8c-.4-.4-.4-1,0-1.4s1-.4,1.4,0l2.5,2.5c0,0,.2.2.2.3,0,.1,0,.2,0,.4h0c0,.1,0,.3,0,.4,0,.1-.1.2-.2.3l-2.5,2.5c-.2.2-.5.3-.7.3Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/Log_Out.9c810e7091d3b13802eccdac8dfe73e4.svg";
export { ForwardRef as ReactComponent };